module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_gellivare-3e3537e7333b3eefdec6420e832e3688.png";